import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './LatestArticles.css';
import config from "../../config";
import { getProjectCategory, getProjectApi, getItemListSize,putProjectViewCount } from "../../api";
const LatestArticles = () => {

  const [data1, setData1] = useState([]);
  const [project, setProject] = useState({});
  const [categoryList, setCategoryList] = useState([]);

  const getAPI = async()=>{


    const res =  getProjectCategory();			
    const res1 =  getProjectApi(config.project.id);		
    const res3 =  getItemListSize(6);
     // const res3 =  getItemSliderList();
 
  
    Promise.all([res,res1,res3]).then((sonuclar)=>{
      //console.log("sonuclar ",sonuclar);
      setCategoryList(sonuclar[0].data);
          setData1(sonuclar[2].data);
          setProject(sonuclar[1].data);
          
         
    })
  
      putProjectViewCount({})
  
      }
      useEffect(() => {
        getAPI(); 
      }, [])
  
      console.log("categoryList ",categoryList);
      console.log("data1 ",data1);
      console.log("project ",project);


  const articles = [
    {
      id: 1,
      title: 'Emin Barına Ait Bilinmeyen Bir Kitabe',
      englishTitle: 'An Unknown Inscription by Emin Barın',
      image: 'https://picsum.photos/400/300',
      author: {
        name: 'Sema BİLİCİ',
        title: ' Dr. Öğr. Üyesi',
      
      },
      content: `Erken Cumhuriyet dönemi modernleşme sürecinde, yaşamın her alanına yansıyan yeni politikalar sağlık alanında da etkili 
olmuş; Osmanlı döneminde inşa edilmiş sağlık yapılarının yeniden yapılandırılması amacına yönelik olarak kapsamlı çalışmalar 
gerçekleştirildiği gibi yeni hastane binaları da inşa edilmiştir.
 MEMLEKET HOSPITAL IN BURSA AND AN UNKNOWN 
INSCRIPTION OF EMIN BARIN
 Türk-İslâm vakıf kültürü içerisinde halkın sağlık ihtiyaçlarının karşılanması amacı ile kurulan darüşşifalar, Selçuklu ve Osmanlı 
dönemlerinde vakıflara bağlı olarak varlıklarını sürdürmüşlerdir. Osmanlı döneminde sağlık hizmetlerinin modernleştirilmesine yönelik 
çalışmalar Tanzimat döneminde askeri alanda başlamış; ilk modern hastane 1799 yılında Levent Çiftliği askeri kışlasında inşa 
edilmiştir. Sivil halka yönelik sağlık hizmetleri ise 19. yüzyılın ortalarında ivme kazanmış, kimsesiz gariplerin ücretsiz tedavisi amacı ile 
vilayet ve sancak merkezleri başta olmak üzere Gurebâ Hastaneleri a ılmıştır (Metin, 2021: 153-154; Yaşayanlar, 2022: 482).
 Osmanlı döneminde ilk sivil hastane, 1837 yılında Edirnekapı Mihrimah Sultan Külliyesi avlusuna yapılan barakalarda, kimsesiz bekâr 
erkek hastaların tedavisi amacı ile açılan "Edirnekapı Gurebâ ve Bekâr Hastahanesi"dir (Karaaslan, 2015: 73). Ardından Müslüman sivil 
halkın sağlık gereksinimlerini ücretsiz olarak karşılamak üzere 1845 yılında "Bezm-i Âlem Gurebâ-yı Müslimîn Hastahanesi" ve 1849 
yılında "İzmir Gurebâ Hastahanesi" hizmete girmiş; hastane yapıları sultan II. Abdülhamid döneminde imparatorluğun diğer vilayetlerine 
de yayılarak gelişmiştir (Akpınar, 2019: 221).
 Sultan II. Abdülhamid döneminde, sultanın adına izafeten "Hamidiye Gurebâ" olarak anılmaya başlanan Gurebâ Hastaneleri, 
Cumhuriyet'in ilk yıllarından itibaren "Memleket Hastanesi", 1950'li yıllardan sonra da Devlet Hastanesi adını almıştır (Karaaslan, 
2015: 72-73). 
Türkiye Büyük Millet Meclisinin açılmasının hemen ardından sağlık hizmetlerinin yürütülmesi görevi, 2 Mayıs 1920 ve 3 sayılı Kanun ile 
kurulan "Sıhhiye ve Muavenet-i İçtimâiye Vekâleti"ne verilerek; gerekli görülen yerlerde hastaneler, sanatoryumlar, ruh ve sinir  hastalıkları hastaneleri, doğum-çocuk bakım evleri ve kuduz tedavi müesseseleri kurmakla yetkilendirilmiştir. 1923 yılında ülke 
genelinde, üç "Memleket Hastanesi", altı "Belediye Hastanesi", 45 "Özel İdare Hastanesi" ve 32 "Özel, Yabancı ve Ekalliyet Hastanesi" 
bulunduğu anlaşılmaktadır (Şenyurt ve Erol, 2016: 66).
 Erken Cumhuriyet döneminde Konya, Manisa, Kütahya, Yozgat, Tokat, Çanakkale, Mersin, Antalya, Van, Kırşehir, Ağrı, Ordu, Amasya, 
Eskişehir, Niğde, Bilecik, Bursa, İzmir, Kocaeli ve Samsun'da yeni Memleket Hastaneleri açılmış; Kastamonu, Denizli, Gümüşhane, 
Çorum, Malatya, Aydın, Burdur, Çankırı'daki Memleket Hastaneleri'nin inşaatları da tamamlanma aşamasına gelmiştir. Sıhhiye ve 
Muavenet-i İçtimâiye Vekâleti, sağlık kuruluşlarının yeniden düzenlenmesi amacına yönelik olarak 1924 yılında, Zonguldak Özel 
İdaresi'ne ait Memleket Hastanesi ve Vakıflar İdaresine bağlı İstanbul Gurebâ Hastanesini bünyesine almıştır. 1954 yılından sonra ise 
Özel İdarelere ait olan "Memleket Hastaneleri" Sağlık Bakanlığı'na bağlanarak, adları "Devlet Hastanesi" olarak değiştirilmiştir (Şenyurt 
ve Erol, 2016: 66).
 1- Hamidiye Gurebâdan Memleket Hastanesine Uzanan Süre.
 Bursa'nın Hisar semtinde, "Eski Saray" olarak adlandırılan mevkide yer alan Damat Efendi Konağı'nın satın alınarak yenilenmesi 
suretiyle 1868 yılında açılan Gurebâ Hastanesinin, yapılan ek binalara rağmen yetersiz kalması üzerine 1946 yılında yeni hastane 
binasının inşasına başlanmıştır. Geçirdiği yangının ardından 1956 yılında yıktırılarak günümüze ulaşamayan Gurebâ Hastanesi, eski 
fotoğraf ve belgeler esas alınarak çeşitli araştırmalara konu edilmiştir.
 1863 yılında "Anadolu Sağ Kol Ciheti Müfettişi" sıfatı ile Batı Anadolu Bölgesinde görevlendirilen Ahmed Vefik Efendi Bursa'da 
yürüttüğü çalışmalarda, 1855 depreminde harabeye dönüşmüş birçok tarihi eseri ayağa kaldırarak, yeni yapılar tesis etmiştir. Bu 
çalışmalar sırasında Yıldırım Darüşşifası'nın kullanılamaz durumda olduğunu gören Vefik Efendi, Hisar semtinde Bursa ovasını gören bir 
tepe üzerinde yer alan Damat Efendi Konağı'nı satın alarak, burayı hastaneye dönüştürmek üzere çalışmaları başlatmıştır (Foto. 
No. 1). Müfettişlik görevinden azledilmesi üzerine hastanenin 1868'deki açılışında bulunamayan Vefik Efendi, 1879 yılında, merkezi 
Bursa olan Hüdâvendigâr vilayetine "paşa" ünvanı ile vali olarak atanınca hastane ile yeniden ilgilenmeye başlamıştır (Yaşayanlar, 
2022: 482).
 Hastane binasının idaresi, Bursa eşrafından Bahaeddin Efendi adlı bir kişiye verilerek; 45'i erkeklere ve 15'i kadınlara mahsus olmak 
üzere 60 yataklı bir hastane kurulmuştur. Hastanenin giderlerinin karşılanabilmesi amacı ile Bursa'daki Sırmakeş ve Mahmut Paşa 
Hanları ile Balık Hanı, ayrıca Çitli maden suyu ile Paşa'nın sahip olduğu tiyatro binasından elde edilen gelirlerin hastaneye aktarılması 
yönünde düzenleme yapılmış, şehir merkezine getirilip satılan odunlardan alınan vergiler de hastaneye gelir olarak kaydedilmiştir 
(Tansel, 1964: 130-131; Karaaslan, 2015:74).
 1904 yılında, dönemin Bursa Valisi Reşit Mümtaz Paşa'nın girişimleri ile hastane binası, İmaret-i İsa Bey Medresesi'ni içine alacak 
şekilde batıya doğru genişletilerek mutfak, ambar ve çamaşırhane gibi yeni yapılar eklenmiştir`
    },
    {
      id: 2,
      title: 'Mimar Kemaleddin Bey',
      englishTitle: 'Architect Kemaleddin Bey',
      image: 'https://picsum.photos/400/300?random=2',
      author: {
        name: 'Tolga BOZKURT',
        title: 'Prof. Dr.'
      }
    },
    {
      id: 3,
      title: 'Müstakil Ressamlar ve Heykeltıraşlar Birliği',
      englishTitle: 'Independent Painters and Sculptors Association',
      image: 'https://picsum.photos/400/300?random=3',
      author: {
        name: 'Kıymet GİRAY',
        title: 'Prof. Dr.'
      }
    },
    {
      id: 4,
      title: 'Ressam Hale Asaf',
      englishTitle: 'Painter Hale Asaf',
      image: 'https://picsum.photos/400/300?random=4',
      author: {
        name: 'Burcu PELVANOĞLU',
        title: 'Prof. Dr.'
      }
    }
  ];

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  };

  return (
    <section className="latest-articles">
      <Container>
        <h2 className="section-title">Son Eklenen Yazılar</h2>
        <div className="slider-container">
          <Slider {...settings}>
            {data1.map(article => (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                state={{
                  articleInfo: {
                    title: article.title,
                    englishTitle: article.englishTitle,
                    author: article.writerName,
                    definition: article.definition,
                    content: article.content,
                    image: article.primaryImage
                  }
                }}
                className="article-link"
              >
                <div className="latest-article-card">
                  <div className="article-image-container">
                    <img 
                      src={article.primaryImage ? article.primaryImage : '/images/AKM_CDTST_LOGO_TEKLI_3.png'} 
                      style={article.primaryImage ?{width: '100%', height: '100%', objectFit: 'cover'} : {width: '100%', height: '100%', objectFit: 'contain'}}
                      alt={article.title} 
                      className="article-image" 
                    />
                  </div>
                  <div className="article-content">
                    <h3 className="article-title">{article.title}</h3>
                    <span className="article-english-title">{article.definition}</span>
                    <div className="article-author">
                      <div className="author-info">
                        <div className="author-frame">
                          <span className="author-name">{article.writerName ? article.writerName.replace(/,/g, ',\n') : ''}</span>
                          <img src="/images/tugikip/kenarlik.png" alt="Edit" className="edit-icon" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </Slider>
        </div>
      </Container>
    </section>
  );
};

export default LatestArticles; 